export default __webpack_public_path__ + "static/media/0.a40ba7fc.png";